module.exports = __webpack_public_path__ + "static/img/fuli_pc2.b57711f6.jpg";